export default __webpack_public_path__ + "static/media/kuchnia10.ac09bec2.jpg";